import * as React from "react"

const SteeringWheel = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152.5 96.2" {...props}>
    <title>{"parcel-journey-5-steering-wheel-icon-2"}</title>
    <path
      d="M104.4 8.6h.9l-1.2-2.1H0L5.8 15H91c2.3-5.2 7.7-6.4 13.4-6.4ZM65.7 39.3H18.9l5.8 8.4h42.7c-2.4-4.8-2.2-6.6-1.7-8.4ZM73.8 23H9.5l5.8 8.4h57.4c-1.6-4.9-.3-6.8 1.1-8.4Z"
      fill="#4ead90"
    />
    <path
      d="M104.4 96.2a48.1 48.1 0 1 1 48.1-48.1 48.18 48.18 0 0 1-48.1 48.1Zm0-74.2a26.1 26.1 0 1 0 26.1 26.1A26.12 26.12 0 0 0 104.4 22Z"
      fill="#fff"
    />
    <path
      d="M104.4 6a42.1 42.1 0 1 0 42.1 42.1A42.17 42.17 0 0 0 104.4 6Zm0 10a32.22 32.22 0 0 1 28.1 16.5l-21.1 6.2a11.11 11.11 0 0 0-7-2.3 11.45 11.45 0 0 0-7.2 2.5l-21-6.2A32.36 32.36 0 0 1 104.4 16ZM72.3 48.1a29.62 29.62 0 0 1 .7-6.6l20 8.7a11.67 11.67 0 0 0 5.5 7.8l1.3 21.8a32.1 32.1 0 0 1-27.5-31.7Zm36.8 31.8 1.3-21.8a11.41 11.41 0 0 0 5.5-8.2l19.9-8.6a31.06 31.06 0 0 1 .7 6.9 32.17 32.17 0 0 1-27.4 31.7Z"
      fill="#4ead90"
    />
  </svg>
)

export default SteeringWheel
